document.addEventListener('DOMContentLoaded', function() {
    // Set default option and form display
    const option1 = document.getElementById('option1');
    const option2 = document.getElementById('option2');
    const paket1 = document.getElementById('paket1');
    const paket2 = document.getElementById('paket2');
    const form1 = document.getElementById('form1');
    const form2 = document.getElementById('form2');

    // Function to update the selection and form visibility
    function updateSelection(selectedOption) {
        if (selectedOption === 'option1') {
            option1.checked = true;
            paket1.classList.replace(
                'border-primary-650',
                'border-primary-500',
            );
            paket2.classList.replace(
                'border-primary-500',
                'border-primary-650',
            );
            form1.style.display = 'block';
            form2.style.display = 'none';
        } else if (selectedOption === 'option2') {
            option2.checked = true;
            paket1.classList.replace(
                'border-primary-500',
                'border-primary-650',
            );
            paket2.classList.replace(
                'border-primary-650',
                'border-primary-500',
            );
            form1.style.display = 'none';
            form2.style.display = 'block';

        }
    }

    // Set default selection on page load
    updateSelection('option1');

    // Add click event listeners to the packages
    paket1.addEventListener('click', function() {
        updateSelection('option1');
    });

    paket2.addEventListener('click', function() {
        updateSelection('option2');
    });

    // Add click event listeners to the radio buttons
    option1.addEventListener('click', function() {
        updateSelection('option1');
    });

    option2.addEventListener('click', function() {
        updateSelection('option2');
    });
});

document.getElementById('unit-add').addEventListener('click', function() {
    let extraUnits = document.getElementById('extra_units');
    let inputContainer = document.querySelector('.ginput_container_number');
    let inputField = inputContainer.querySelector('.gift-value input');
    let currentValue = parseInt(extraUnits.textContent);
    extraUnits.textContent = currentValue + 50;
    inputField.value = currentValue + 50;

    // Simulate change in input value
    let event = new Event('input', {
        bubbles: true,
        cancelable: true,
    });
    inputField.dispatchEvent(event);

});

document.getElementById('unit-remove').addEventListener('click', function() {
    let extraUnits = document.getElementById('extra_units');
    let inputContainer = document.querySelector('.ginput_container_number');
    let inputField = inputContainer.querySelector('.gift-value input');
    let currentValue = parseInt(extraUnits.textContent);
    if (currentValue > 50) {
        extraUnits.textContent = currentValue - 50;
        inputField.value = currentValue - 50;

        // Simulate change in input value
        let event = new Event('input', {
            bubbles: true,
            cancelable: true,
        });
        inputField.dispatchEvent(event);

    }
});

/**/

document.getElementById('unit-add-2').addEventListener('click', function() {
    let extraUnits = document.getElementById('extra_units-2');
    let inputField = document.querySelector('.kvitto-value input');
    let currentValue = parseInt(extraUnits.textContent);
    extraUnits.textContent = currentValue + 1;
    inputField.value = currentValue + 1;

    // Simulate change in input value
    let event = new Event('input', {
        bubbles: true,
        cancelable: true,
    });
    inputField.dispatchEvent(event);

});

document.getElementById('unit-remove-2').addEventListener('click', function() {
    let extraUnits = document.getElementById('extra_units-2');
    let inputField = document.querySelector('.kvitto-value input');
    let currentValue = parseInt(extraUnits.textContent);
    if (currentValue > 1) {
        extraUnits.textContent = currentValue - 1;
        inputField.value = currentValue - 1;

        // Simulate change in input value
        let event = new Event('input', {
            bubbles: true,
            cancelable: true,
        });
        inputField.dispatchEvent(event);

    }
});
